<template>
<div class="SmallProceduresPush">
</div>
</template>

<script>
export default {
    name: 'SmallProceduresPush',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.SmallProceduresPush {
}
</style>
